import React, { createContext, useContext, useState } from "react";

export type InterceptorFn = (actionType?: "back" | "tab-switch") => Promise<boolean>;

interface NavigationContextType {
  interceptor: InterceptorFn | null;
  setInterceptor: React.Dispatch<React.SetStateAction<InterceptorFn | null>>;
  isSwitchingTab: boolean;
  setIsSwitchingTab: (val: boolean) => void;
}

const NavigationContext = createContext<NavigationContextType>({
  interceptor: null,
  setInterceptor: () => {},
  isSwitchingTab: false,
  setIsSwitchingTab: () => {},
});

export const useNavigationInterceptor = () => useContext(NavigationContext);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [interceptor, setInterceptor] = useState<InterceptorFn | null>(null);
  const [isSwitchingTab, setIsSwitchingTab] = useState(false);

  return (
    <NavigationContext.Provider
      value={{
        interceptor,
        setInterceptor,
        isSwitchingTab,
        setIsSwitchingTab,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
